import enTranslationSurveyStatus from "./en/translation-survey-status.json";
import enTranslationProjects from "./en/translation-projects.json";
import enTranslationEmailCycles from "./en/translation-email-cycles.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationFilters from "./en/translation-filters.json";
import enTranslationEmailTemplates from "./en/translation-email-templates.json";
import enTranslationExternalPublicApis from "./en/translation-external-public-apis.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";
import enTranslationErrors from "./en/translation-errors.json";
import enTranslationManageUsers from "./en/translation-manage-users.json";

export const eagleEnTranslation = {
  surveyStatus: enTranslationSurveyStatus,
  projects: enTranslationProjects,
  emailCycles: enTranslationEmailCycles,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  common: enTranslationCommon,
  filters: enTranslationFilters,
  emailTemplates: enTranslationEmailTemplates,
  externalPublicApis: enTranslationExternalPublicApis,
  surveys: enTranslationSurveys,
  surveyDashboard: enTranslationSurveyDashboard,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
  welcomePage: enTranslationWelcomePage,
  errors: enTranslationErrors,
  manageUsers: enTranslationManageUsers,
};
